const { mergeAll, pathOr } = require('ramda');

const { drawCube, drawPyram, drawMegaminxLL } = require('./app');

class CubePreview {
  constructor() {
    this.colorScheme = {
      cube: {
        U: 'white',
        R: 'red',
        F: 'green',
        D: 'yellow',
        L: 'orange',
        B: 'blue',
      },
      pyram: {
        L: 'red',
        F: 'green',
        R: 'blue',
        D: 'yellow',
      },
      minx: {
        U: 'Black',
        R: 'Grey',
        F: 'Yellow',
        L: 'Orange',
        Bl: 'LightBlue',
        Br: 'Green',
      },
    };
    this.cubieSize = 20;
    this.draw = {
      cube: drawCube,
      pyram: drawPyram,
      minx: drawMegaminxLL,
    };
    this.spacing = 2;
    this.type = 'cube';
    this.size = 3;
  }

  setType(type) {
    this.type = type;
    this.size = type / 111;

    return this;
  }

  setColorScheme(colorScheme) {
    this.colorScheme[this.type] = mergeAll([
      this.colorScheme[this.type],
      colorScheme,
    ]);
    return this;
  }

  setCubieSize(cubieSize) {
    this.cubieSize = cubieSize;
    return this;
  }

  setSpacing(spacing) {
    this.spacing = spacing;
    return this;
  }

  svgString(state) {
    return pathOr(this.draw.cube, [this.type], this.draw)({
      colorScheme: pathOr(this.colorScheme.cube, [this.type], this.colorScheme),
      cubieSize: this.cubieSize,
      size: this.size,
      spacing: this.spacing,
      state,
    });
  }
}

module.exports = { CubePreview };
